import TextPage from './text-page';
export default TextPage;